/*
   본 소프트웨어는 관련 법률에 따라 보호되는 삼성의 지식재산 및 영업비밀 입니다. 본 소프트웨어를 권한 없이 사용하거나 삼성의 사전 서면 동의 없이 제3자에게 공개하는 행위는
   엄격히 금지되어 있으며 위반 시 귀하는 무단 사용 또는 비밀 유지 의무 위반에 대해 법적인 책임을 져야 합니다. This software is the intellectual
   property and confidential information of Samsung Electronics, Co., Ltd. (“Samsung”) protected by
   applicable laws. The unauthorized use or disclosure of the software to any third party without
   the prior written consent of Samsung is strictly prohibited, and you should be legally
  responsible for the unauthorized use or violation of confidentiality obligation.
*/
import axios from 'axios';
import _ from 'lodash';
import SDLUtil from '@/utils/SDLUtil';

let storeFetch = null;
export const fetchMenuAll = async (forceRemote = true) => {
  if (storeFetch == null || forceRemote) {
    storeFetch = await axios.get(`${SDLUtil.API_URL}/auth/menus-user-auth`);
  }
  return storeFetch;
};

let storeMenus = [];

export default {
  async getMenus(forceRemote = false) {
    if (storeMenus.length === 0 || forceRemote) {
      try {
        const menuResponse = await fetchMenuAll(forceRemote);
        storeMenus = menuResponse.data.map(menu => {
          const defaultPage = _.find(menu.pages, ['defaulted', true]);
          if (defaultPage) {
            menu.menuUrl = defaultPage.pagePath;
            menu.componentName = defaultPage.componentName;
            menu.defaultPage = defaultPage;
          } else {
            menu.menuUrl = '/emptypage';
            menu.componentName = 'admin/main/EmptyPage';
          }
          // menu.isGroup = menu.pages.length > 0; // TODO 메뉴쪽 후에 외부링크 추가되면 로직추가 필요
          return menu;
        });
        return storeMenus;
      } catch (error) {
        console.error(error);
        return [];
      }
    } else {
      return Promise.resolve(storeMenus);
    }
  },
};



// WEBPACK FOOTER //
// ./src/service/menuService.js